/* eslint quotes: 0 */
export default {
  "container": {
    "containerSearchInProgress": "Recherche de conteneurs en cours",
    "noContainersWithSufficientProductQuantityFound": "Aucun conteneur contenant des quantités suffisantes du produit sélectionné n'a été trouvé.",
    "searchForProductInContainers": "Rechercher le produit dans les conteneurs"
  },
  "contractor": {
    "acceptanceDate": "Date d'acceptation",
    "all": "Tous",
    "chooseContractor": "Sélectionner un entrepreneur",
    "chooseEndedStatus": "N’afficher que les complétés ?",
    "chooseSettlementStatus": "Sélectionner le statut de facturation",
    "contractor": "Entrepreneur",
    "dateOfSampleAndAcceptance": "Date d'essai et d’acceptation",
    "listOfContractorsWorksToBeSettled": "Liste des travaux des entrepreneurs à facturer",
    "makeSettlementErrorText": "La facturation a échoué Réessayer.",
    "noItemsToBeSettled": "Aucun élément à facturer",
    "onlyEnded": "Uniquement les complétés",
    "serviceCost": "Coût de la marquage",
    "toBeSettled": "À facturer",
    "unitPrice": "Prix unitaire"
  },
  "contractorsSettlementsImportPopup": {
    "importSuccessDesc": "Données importées depuis un fichier XLSX",
    "importSuccessTitle": "Données importées",
    "importTitle": "Importation de la liste de travaux des entrepreneurs à facturer",
    "importXlsx": "Importer un XLSX",
    "xlsxFile": "Fichier XLSX"
  },
  "customer": {
    "addAddress": "Ajouter une adresse",
    "addAddressErrorText": "L'ajout de l’adresse a échoué. Réessayer.",
    "addAddressSuccessText": "L’adresse fournie a été sauvegardée",
    "addAddressSuccessTitle": "Adresse ajoutée",
    "addContactPerson": "Ajouter un interlocuteur",
    "addContactPersonErrorText": "L'ajout de l’interlocuteur a échoué. Réessayer.",
    "addContactPersonSuccessText": "L'interlocuteur fourni a été sauvegardé",
    "addContactPersonSuccessTitle": "Interlocuteur ajouté",
    "addCustomer": "Ajouter un client",
    "addCustomerErrorText": "L'ajout du client a échoué. Réessayer.",
    "addCustomerSuccessText": "Le client fourni a été sauvegardé",
    "addCustomerSuccessTitle": "Client ajouté",
    "addErrorText": "Échec de l'ajout du client",
    "addNewCustomer": "Ajouter un nouveau client",
    "addSuccessText": "Un client a été créé à partir des données fournies.",
    "addSuccessTitle": "Client ajouté",
    "addingContactPersonAvailableAfterCustomerSave": "L'ajout d’interlocuteurs sera possible une fois que le client aura été sauvegardé.",
    "addingNewCustomer": "Ajout d’un nouveau client",
    "addingShippingAddressAvailableAfterCustomerSave": "L'ajout d'adresses de livraison sera possible une fois que le client aura été sauvegardé.",
    "addingTransaltionsAvailableAfterCustomerSave": "L'ajout de traductions sera possible une fois que le client aura été sauvegardé.",
    "building": "Immeuble",
    "buildingNumber": "Numéro d'immeuble",
    "changePassword": "Modifier le mot de passe",
    "changeYourPassword": "Modifiez votre mot de passe",
    "city": "Ville",
    "company": "Société",
    "companyName": "Nom de la société",
    "contact": {
      "contact": "Contact"
    },
    "contactAddress": "Adresse de contact",
    "contactPeople": "Interlocuteurs",
    "correspondenceAddressSet": "Données modifiées",
    "correspondenceAddressSetDesc": "Ensemble d'adresses postales",
    "correspondenceInfo": "Coordonnées :",
    "customerCountryQuestionMark": "Pays du client ?",
    "customerLogo": "Logo du client",
    "customers": "Clients",
    "customersList": "Liste des clients",
    "deleteAddressConfirmTitle": "Êtes-vous sûr de vouloir supprimer cet adresse ?",
    "deleteAddressErrorText": "La suppression de l’adresse a échoué. Réessayez.",
    "deleteAddressSuccessText": "L’adresse sélectionnée a été supprimée",
    "deleteAddressSuccessTitle": "Adresse supprimée",
    "deleteContactPersonConfirmTitle": "Êtes-vous sûr de vouloir supprimer cet interlocuteur ?",
    "deleteContactPersonErrorText": "La suppression de l’interlocuteur a échoué. Réessayez.",
    "deleteContactPersonSuccessText": "L'interlocuteur sélectionné a été supprimé",
    "deleteContactPersonSuccessTitle": "Interlocuteur supprimé",
    "discount": {
      "deliveryDiscount": "Réduction pour la livraison",
      "productDiscount": "Réduction pour les produits",
      "servicesDiscount": "Réduction pour les marquages"
    },
    "edit": "Modification du client",
    "editAddress": "Modifier l’adresse",
    "editAddressErrorText": "La modification de l'adresse a échoué. Réessayez.",
    "editAddressSuccessText": "L'adresse indiquée a été modifiée",
    "editAddressSuccessTitle": "Adresse modifiée",
    "editClientErrorText": "La modification du client a échoué. Réessayez.",
    "editClientSuccessText": "Les données du client ont été modifiées",
    "editClientSuccessTitle": "Client modifié",
    "editContactPerson": "Modifier l'interlocuteur",
    "editContactPersonErrorText": "La modification de l’interlocuteur a échoué. Réessayez.",
    "editContactPersonSuccessText": "L'interlocuteur indiqué a été modifié",
    "editContactPersonSuccessTitle": "Interlocuteur modifié",
    "editPasswordErrorText": "La modification du mot de passe a échoué. Réessayez.",
    "editPasswordSuccessText": "Le mot de passe a été modifié",
    "editPasswordSuccessTitle": "Mot de passe modifié",
    "enterCustomerData": "Saisir les données du client",
    "fountAddresses": "Adresses trouvées :",
    "getDataFromGUS": "Récupérer les données depuis le GUS",
    "getDataFromVIES": "Récupérer les données depuis VIES",
    "houseNumber": "Numéro d'appartement",
    "invoiceAddressSet": "Données modifiées",
    "invoiceAddressSetDesc": "Les données de facturation ont été définies",
    "invoiceAndCorrespondenceAddressSet": "Données modifiées",
    "invoiceAndCorrespondenceAddressSetDesc": "Les données de facturation et de correspondance ont été définies",
    "invoiceInfo": "Données de facturation",
    "invoiceName": "Nom sur la facture",
    "isOrdersInRpogress": "Commandes en cours ?",
    "maxAddressSearchResults": "Un maximum de 50 adresses correspondantes est affiché. Si vous ne trouvez pas l'adresse dont vous avez besoin, réduisez vos critères de recherche.",
    "newsletterAgreement": "Consentement à la newsletter",
    "noAddressesToDisplay": "Aucune adresse à afficher",
    "noContactPeopleToDisplay": "Aucun interlocuteur à afficher",
    "noCustomerMarchingPhraseFound": "Aucun client ne correspond à la phrase indiquée",
    "noCustomersToDisplay": "Aucun client à afficher",
    "noTranslationsForThisClient": "Aucune traduction pour ce client",
    "notFoundInVIESGUSTitle": "Introuvable",
    "notFoundInVIESGUSText": "L’entreprise indiquée n’a pas été trouvée dans la base de données",
    "offersInProgress": "Devis en cours",
    "ordersAndOffers": "Commandes et devis",
    "ordersInProgress": "Commandes en cours",
    "passowrdChange": "Modification du mot de passe",
    "person": "Personne",
    "phoneShortCap": "Tél.",
    "profile": "Profil",
    "removeCustomerConfirmTitle": "Êtes-vous sûr de vouloir supprimer ce client ?",
    "removeCustomerErrorText": "La suppression du client a échoué. Réessayez.",
    "removeCustomerSuccessText": "Le client sélectionné a été supprimé",
    "removeCustomerSuccessTitle": "Client supprimé",
    "removeLogo": "Supprimer le logo",
    "searchAddressesByCompanyNameAddressOrContactInfo": "Rechercher les adresses par nom d'entreprise, adresse ou coordonnées",
    "selectCustomer": "Sélectionner un client",
    "shippingInfo": "Données d'expédition",
    "showCustomerDrafts": "Afficher les devis",
    "showCustomerOrders": "Afficher les commandes",
    "statistics": "Statistiques",
    "stockReportsNotifications": "Notification des stocks",
    "street": "Rue",
    "telephone": "Téléphone",
    "termsOfSale": "Conditions de vente",
    "unsettledInvoices": "Factures non payées",
    "vatIDNumber": "NIP/ TVA ID",
    "verificationIntegrationDisabledDesc": "Il servizio di recupero dati non è attualmente disponibile",
    "verificationIntegrationDisabledTitle": "Servizio non disponibile",
    "withOrdersInProgress": "Avec les commandes en cours",
    "withoutOrdersInProgress": "Aucune commande en cours",
    "youMustSelectCountryPrefix": "Seleziona il prefisso del paese",
    "youMustSelectCountryPrefixDesc": "Per recuperare i dati è necessario specificare il prefisso del paese",
    "yourAccount": "Votre compte",
    "zipCode": "Code postal"
  },
  "customerOrdersPopup": {
    "offers": "Devis client",
    "orders": "Commande client"
  },
  "dashboard": {
    "customersPopup": {
      "customerEmail": "E-mail",
      "customerName": "Nom du client",
      "customerPhone": "Téléphone",
      "title": "Envoyer la demande aux clients"
    }
  },
  "errorPage": {
    "errorCode": "404",
    "pageDoesNotExist": "La sous-page sélectionnée n'existe pas",
    "tryAgainLaterOrContactAdministrator": "Réessayez plus tard ou contactez l’administrateur du système."
  },
  "inquiries": {
    "addComments": "Ajoutez vos notes",
    "addFirstProductInstructionInfo": "Ajoutez votre premier produit en cliquant sur \"+ Produit\"",
    "addFirstServiceInstructionInfo": "Ajoutez votre première marquage générique en cliquant sur \"+ marquage générique\"",
    "caanotCreateOrder": "Impossible de créer une commande",
    "failedToAddProductsToOrder": "Aucun produit ajouté à la commande",
    "executionTime": "Délai de réalisation",
    "globalServicesTooltip": "Si de nombreux produits ont la même marquage, ajoutez une marquage générique à partir d'ici. Nous ne calculons alors qu'une seule fois le coût de configuration. Vous pourrez diviser le nombre de marquages que vous commandez en produits individuels.",
    "needExecutionTill": "J'ai besoin l’exécution jusqu’au",
    "noComments": "Aucun commentaire",
    "noDateSelected": "Aucun délai",
    "orderAdditionalInfo": "Commentaires supplémentaires à la commande",
    "selectExecutionTime": "Sélectionnez le délai de réalisation",
    "trackingNumber": "Numéro de suivi",
    "unexpectedErrorOccured": "Une problème inattendue s'est produite"
  },
  "login": {
    "authError": "Erreur d'autorisation. Réessayez",
    "emailPlaceholder": "Votre adresse e-mail",
    "loginInProgress": "Connexion...",
    "loginLabel": "Se connecter",
    "password": "Mot de passe",
    "passwordPlaceholder": "********",
    "register": "Vous n’avez pas de compte?",
    "resetPassword": "Mot de passe oublié?"
  },
  "noPermissions": {
    "noPermissionsDescription": "Si vous pensez qu'il s'agit d'une erreur, contactez l’administrateur système.",
    "noPermissionsText": "Vous n'êtes pas autorisé à consulter cette page",
    "noPermissionsTitle": "Pas d’autorisation"
  },
  "order": {
    "addNewDraft": "Ajouter un nouveau devis",
    "addNewFemenine": "Ajouter un nouveau",
    "addNewOrder": "Ajouter une nouvelle commande",
    "addNewShippingAddress": "Ajouter une nouvelle adresse de livraison",
    "addedProducts": "Les produits suivants ont été ajoutés :",
    "addressRemoved": "L'adresse précédemment utilisée a été supprimée. Veuillez sélectionner une nouvelle adresse.",
    "awaitingInvoice": "en attente de facturation",
    "awaitingProductionComplete": "en attente de l'achèvement de la production",
    "awaitingSample": "en attente de l’essai",
    "awaitingSampleAcceptance": "en attente de l'approbation de l'essai",
    "beeingCollected": "Au cours de la collecte",
    "blockade": "Verrou",
    "cartonsMissingInfo": "Le nombre de cartons peut devoir être ajusté car certains produits n'ont pas un nombre défini de pièces par carton.",
    "cartonsNumber": "Nombre de cartons",
    "checkFormDesc": "Lors de la validation, des erreurs ont été trouvées et doivent être corrigées. Veuillez vérifier les onglets du formulaire et corriger les erreurs trouvées.",
    "checkFormTitle": "Vérifiez le formulaire",
    "chooseShippingAddress": "Sélectionner l’adresse de livraison",
    "clientContactPerson": "Interlocuteur du client",
    "connectedInvoices": "Factures associées",
    "currentDiscountOfCustomer": "La remise enregistrée dans le profil client est de",
    "customerAndName": "Client  et nom",
    "customerDiscounts": "Remises client",
    "dashOrderAwaitingShipping": "- commandes en attente d'expédition",
    "dashReadyForShipping": "- prêtes pour l’expédition",
    "dateOfIssue": "Date d'émission",
    "deleted": "Supprimées",
    "delivery": "Livraison",
    "download": "Télécharger",
    "downloadPDF": "Télécharger un PDF",
    "downloadPDFforMe": "Offre pour mon ENTREPRISE",
    "downloadPDFforMyCustomer": "Offre pour mon CLIENT",
    "downloadXls": "Télécharger un XLS",
    "draftDeleteConfirmTitle": "Êtes-vous sûr de vouloir supprimer ce devis ?",
    "draftDeleteErrorText": "La suppression du devis a échoué. Réessayez.",
    "draftDeleteSuccessText": "Le devis sélectionné a été supprimé",
    "draftDeleteSuccessTitle": "Devis supprimé",
    "draftsList": "Liste des devis",
    "duplicateOrder": {
      "questionTextOffer": "Êtes-vous sûr de vouloir dupliquer ce devis ?",
      "questionTextOrder": "Êtes-vous sûr de vouloir dupliquer cette commande ?",
      "questionTitle": "Confirmer l'opération.",
      "successTextOffer": "Le devis sélectionné a été dupliqué avec succès",
      "successTextOrder": "La commande sélectionnée a été dupliquée avec succès",
      "successTitleOffer": "Devis dupliqué",
      "successTitleOrder": "Commande dupliquée"
    },
    "editDraft": "Modifier le devis",
    "editDraftErrorText": "Impossible de sauvegarder le devis",
    "editDraftSaveSuccessText": "Le devis a été sauvegardé avec succès",
    "editDraftSuccessTitle": "Devis sauvegardé",
    "editingOfferFromHPL1": "Vous modifiez une offre créée pour <strong>votre ENTREPRISE</strong>. Si vous souhaitez la transformer en <strong>offre pour votre CLIENT</strong>, cliquez ",
    "editingOfferFromHPL2": "ici",
    "editingOfferFromHPL3": "N’oubliez pas d’enregistrer l’offre après cette modification.",
    "ended": "Terminés",
    "errors": {
      "shipping_price_not_fetched": "La mise à jour du prix de livraison a échoué. Vérifier le prix de livraison."
    },
    "files": {
      "addingFile": "Ajouter un fichier",
      "deleteFile": "Supprimer le fichier",
      "editFile": "Modifier le fichier",
      "editFileText": "Fournir une description mis à jour du fichier",
      "editFileTitle": "Modification de la description du fichier",
      "fileEditError": "Une erreur s'est produite lors de la modification du fichier Réessayez.",
      "noFilesToDisplay": "Aucun fichier associé à cette commande",
      "noServiceFilesToDisplay": "Aucun fichier associé à cette marquage",
      "removeFileDesc": "Cette opération ne peut pas être annulée",
      "removeFileTitle": "Êtes-vous sûr de vouloir supprimer ce fichier?",
      "title": "Fichiers associés à la commande",
      "uploadError": "Une erreur s'est produite lors de l’ajout du fichier"
    },
    "fileSuffixOfferCustomer": "-OFFRE-CLIENT",
    "fileSuffixOfferMe": "-OFFRE-HPL",
    "forAcceptance": "À accepter",
    "inProduction": "En production",
    "includedCustomerDiscount": "Remise client",
    "includedMarkup": "Marge",
    "invoicesIssued": "Factures émises",
    "lastChange": "dernière modification",
    "lastItemModified": "Dernièrement modifiés",
    "lastItemViewed": "Dernièrement vus",
    "nameCheck": {
      "inProgress": "Je vérifie le nom de la commande",
      "inUse": "Le nom de commande sélectionné est déjà utilisé par d'autres commandes.",
      "isAvailable": "Le nom de commande sélectionné est disponible"
    },
    "noAddressFound": "Aucune adresse sélectionnée",
    "noAddresses": "Aucune adresse",
    "noAddressesForThisClient": "Aucune adresse n'est attribuée au client.",
    "noContactPeople": "Aucun interlocuteur",
    "noInvoicesConnectedToOrder": "Aucune facture n'est liée à cette commande",
    "nonExistingCustomerText": "Le client associé à cette commande a été supprimé. Veuillez réattribuer un client à cette commande.",
    "nonExistingCustomerTitle": "Le client sélectionné n'existe pas",
    "noOffersOrOrdersToDisplay": "Aucun devis ou commande à afficher",
    "noOrderMatchingPhraseFound": "Aucune commande correspondant à la phrase fournie",
    "noTagsMatchingGivenPhrase": "Aucune caractéristique correspondant à la phrase fournie",
    "number": "Numéro",
    "numberOfOrderdProducts": "Nombre de produits commandés",
    "offerCurrency": "Devise du devis",
    "offerLanguage": "Langue du devis",
    "offerPreparedFor": "Offre préparée pour",
    "offerSubmissionDate": "Date de soumission du devis",
    "offersToCheck": "Devis à vérifier",
    "orderNumber": "Numéro de commande",
    "orderPreparedFor": "Commande préparée pour",
    "orderPreview": "Aperçu de la commande",
    "orders": "Commandes",
    "ordersList": "Liste des commandes",
    "ordersXlsFilename": "liste des commandes",
    "paymentDate": "Date de paiement",
    "paymentDeadline": "Échéance",
    "pdfDownloadNoticeDesc": "Vous téléchargez une offre PDF pour vous-même. Ne transmettez pas ce fichier à votre client.",
    "pdfDownloadNoticeTitle": "Attention!",
    "pendingPayment": "En attente du paiement",
    "priceChangePopup": {
      "element": "Élément",
      "new": "Nouvelle valeur",
      "previous": "Valeur précédente",
      "subtitle": "Ces modifications seront prises en compte après l’enregistrement de l’offre",
      "title": "Les modifications de prix suivantes ont été effectuées",
      "type": "Type de modification",
      "types": {
        "globalServiceMultipleFrom": "Multiplicateur de marquage générique",
        "globalServicePrice": "Prix de la marquage générique",
        "globalServiceSetupPrice": "Prix de la configuration de la marquage générique",
        "product": "Produit",
        "serviceMultipleFrom": "Multiplicateur de la marquage",
        "servicePrice": "Prix de la marquage",
        "serviceSetupPrice": "Prix de la configuration de la marquage"
      },
      "changeSource": "Source de la modification",
      "sources": {
        "prices": "Tarif HPL",
        "customer_prices": "Votre tarif"
      }
    },
    "productMinQty": "Qté min.",
    "productsTags": "Caractéristiques des produits",
    "readyForShipping": "Prêts pour l’expédition",
    "saveAsOrder": "Soumettre la commande pour traitement",
    "saveAsOrderNoticeDesc": "Une fois enregistrées en tant que commande, les données ne peuvent plus être modifiées - assurez-vous que toutes les données saisies sont correctes.",
    "saveAsOrderNoticeTitle": "Soumettre la commande pour traitement",
    "saveDraft": "Sauvegarder le devis",
    "see": "Afficher",
    "selectOrder": "Sélectionner la commande",
    "sent": "Envoyées",
    "servicesGenitive": "Marquages",
    "shippingAddress": "Adresse d'expédition",
    "showAddress": "Afficher l'adresse",
    "showContact": "Afficher le contact",
    "summary": "Résumé",
    "toCheckInWarehouse": "À vérifier en magasin",
    "toCollect": "À collecter",
    "toDelete": "À supprimer",
    "totalCost": "Coût total",
    "totalDeliveryCostNet": "Coût de livraison (HT)",
    "useCustomerDiscounts": "Utiliser les remises client",
    "usePartnerPricing": "Utiliser votre tarif pour cette commande",
    "valueForPartnerCustomer": "Valeur de la commande pour le client",
    "waitingForShipping": "En attente d’expédition",
    "waitingPurchaseProducts": "En attente des produits",
    "whoOrders": "Acheteur",
    "whoOrdersMe": "Mon ENTREPRISE",
    "whoOrdersMyCustomer": "Mon CLIENT",
    "withDeadlineApproaching": "à l'approche d'une échéance",
    "yesSave": "Oui, sauvegarder",
    "yourDiscounts": "Vos réductions",
    "yourPrice": "Votre prix"
  },
  "price": {
    "addNewPrice": "Ajouter un nouveau prix",
    "addNewProductPrice": "Ajouter un nouveau prix de produit",
    "addNewServicePrice": "Ajouter un nouveau prix de marquage",
    "addNewSetupPrice": "Ajouter un nouveau prix de configuration",
    "addPrice": "Ajouter un prix",
    "addPriceErrorText": "Échec de l'ajout du prix. Veuillez réessayer.",
    "addPriceSuccessText": "Le prix indiqué a été enregistré",
    "addPriceSuccessTitle": "Prix ajouté",
    "bruttonPrice": "Prix brut",
    "chosenPriceIsSetupPrice": "Le prix indiqué est un prix de configuration (setup)",
    "deletePriceConfirmTitle": "Êtes-vous sûr de vouloir supprimer ce prix ?",
    "deletePriceErrorText": "Échec de la suppression du prix. Veuillez réessayer.",
    "deletePriceSuccessText": "Le prix sélectionné a été supprimé",
    "deletePriceSuccessTitle": "Prix supprimé",
    "differentPriceMultipleFromInfo": "Le multiplicateur de prix \"par pièce à partir de\" appliqué diffère du multiplicateur de prix actuel ({value} pcs)",
    "editPrice": "Modifier le prix",
    "export": "Exporter",
    "exportPrices": "Exporter les listes de prix",
    "exportSuccessfull": "Listes de prix exportées",
    "exportSuccessfullDesc": "Les listes de prix ont été exportées avec succès",
    "importPrices": "Importer les listes de prix",
    "importSuccessfull": "Listes de prix importées",
    "importSuccessfullDesc": "Les listes de prix ont été importées avec succès",
    "includeSetupPrices": "Inclure les frais de configuration (setup)",
    "isSale": "Solde / Promotion",
    "noPricesFoundForServiceGroup": "Aucune liste de prix trouvée pour le groupe de marquage sélectionné",
    "noPricesToDisplay": "Aucun prix à afficher",
    "onlyPriceUpdate": "Mise à jour des prix uniquement",
    "pln": "PLN",
    "plnBrutto": "PLN brut",
    "plnNet": "PLN net",
    "plnVat": "PLN TVA",
    "price": "Prix",
    "priceFlat": "Tarif forfaitaire",
    "priceBox": "Tarif par quantité",
    "price25pcs": "jusqu'à 25 pcs",
    "priceFirstBox": "Premier carton",
    "priceSecondBox": "Deuxième carton",
    "priceNextBox": "Carton suivant",
    "priceBeforeDicount": "Prix avant remise",
    "priceEdit": "Modification du prix",
    "priceFrom": "Prix à partir de",
    "priceImportFrom": "Importation des prix depuis",
    "priceNet": "Prix net",
    "pricePerItem": "Prix par pièce",
    "pricePerItemFrom": "Prix par pièce à partir de {price} pcs",
    "pricePerItemShort": "Prix par pc",
    "prices": "Prix",
    "priceTo": "Prix jusqu'à",
    "pricesLists": "Listes de prix",
    "pricesListsLowCase": "listes de prix",
    "productGenitive": "du produit",
    "productsPricesList": "Liste des prix des produits",
    "quantityFrom": "Quantité à partir de",
    "quantityTo": "Quantité jusqu'à",
    "removeAndReplacePrices": "Supprimer les prix et les rajouter",
    "savePriceErrorText": "Échec de la modification du prix. Veuillez réessayer.",
    "savePriceSuccessText": "Le prix sélectionné a été modifié",
    "savePriceSuccessTitle": "Prix modifié",
    "seePricelist": "Voir la liste de prix",
    "serviceGenitive": "du marquage",
    "servicesPriceList": "Grille tarifaire des marquages",
    "servicesPricesList": "Liste des prix de marquage",
    "setup": "configuration",
    "setupPricesList": "Liste des prix de configuration (setup)",
    "supplierPricesFileNamePrefix": "listes-de-prix-fournisseur-",
    "unitPricesIn": "prix unitaires en",
    "vat": "TVA",
    "vatRate": "Taux de TVA",
    "xlsxFileWithPrices": "Fichier XLSX avec les prix"
  },
  "product": {
    "addGlobalService": "Marquage générique",
    "addGlobalServicesPackage": "Pack de marquage",
    "addProduct": "Produit",
    "breakProductsIntoSeparateOffers": "Diviser les produits en offres distinctes",
    "checkAvailability": "Vérifier les livraisons à venir",
    "enterAdditionalProductDescriptionOptional": "Saisir une description supplémentaire du produit (facultatif)",
    "enterProductNameOrCode": "Saisissez le nom ou le code du produit",
    "globalServices": "Marquages génériques",
    "noProductsMatchingGivenPhrase": "Aucun produit correspondant à la phrase fournie",
    "notIncludedInDiscounts": "Non soumis à des réductions",
    "product": "Produit",
    "productCode": "Code produit",
    "productName": "Nom du produit",
    "products": "Produits",
    "productsCodes": "Codes de produits",
    "selectProduct": "Sélectionner le produit",
    "totalBeforeDiscount": "Avant la réduction",
    "totalMarkup": "Marge incluse",
    "totalProductsCostNet": "Coût des produits (HT)",
    "totalServicesCostNet": "Coût des marquages (HT)",
    "useCustomPartnerPrice": "Utilisez votre propre prix",
    "useDefaultPartnerPrice": "Utilisez le prix par défaut"
  },
  "purchase": {
    "addOrderErrorText": "L'ajout de la commande a échoué. Réessayez.",
    "editOrderSuccessTitle": "Commande sauvegardée",
    "fileDeletedDesc": "Le fichier sélectionné a été supprimé",
    "fileDeletedTitle": "Fichier supprimé",
    "numberOfPiecesNeeded": "Nombre d'unités nécessaires",
    "removeFileInProgress": "Suppression du fichier",
    "yourOrderSaveSuccessText": "Votre commande a été sauvegardé"
  },
  "register": {
    "customerTaxNumber": "Numéro de TVA / SIRET",
    "login": "Se connecter",
    "password": "Mot de passe",
    "passwordConfirmation": "Confirmez le mot de passe",
    "passwordReset": {
      "error": "Échec de la modification du mot de passe",
      "resetLabel": "Changer le mot de passe",
      "resetInProgress": "Enregistrement des modifications",
      "success": "Mot de passe modifié - vous pouvez maintenant vous connecter",
      "title": "Changer le mot de passe"
    },
    "passwordResetRequest": {
      "error": "Échec de la réinitialisation du mot de passe",
      "resetInProgress": "Réinitialisation du mot de passe en cours",
      "resetLabel": "Demander la réinitialisation du mot de passe",
      "success": "Demande de réinitialisation envoyée. Si l'adresse e-mail saisie existe dans le système, vous recevrez des instructions supplémentaires dans votre boîte de réception.",
      "title": "Réinitialiser le mot de passe"
    },
    "registerError": "Échec de l'inscription",
    "registerInProgress": "Inscription en cours",
    "registerLabel": "S'inscrire",
    "registerSuccess": "Compte créé. En attente de vérification et d'approbation.",
    "title": "Créer un compte"
  },
  "service": {
    "addService": "Marquage",
    "addServicesPackage": "Pack de marquage",
    "addServicesPackageBtn": "Ajouter un pack de marquage",
    "chooseEmbroideryPosition": "Sélectionner l’emplacement de la marquage",
    "chooseEmbroideryType": "Sélectionner le type de marquage",
    "chooseService": "Sélectionner la marquage",
    "chooseServiceGroup": "Choisir le groupe de marquage",
    "commonServices": "Marquages communes",
    "complexity": "Niveau de complexité",
    "descriptionFoCustomer": "Description pour le client",
    "detailsOfServiceInOrder": "Détails des marquages dans la commande",
    "downloadLogo": "Télécharger le logo",
    "dstNumber": "Numéro DST",
    "embroidery": {
      "colors": "Couleurs de la marquage",
      "height": "EXP",
      "position": "Emplacement de la marquage",
      "size": "Taille de la marquage (mm)",
      "type": "Type de marquage",
      "width": "LARG"
    },
    "enterServiceNameOrCode": "Saisissez le nom ou le code du marquage",
    "files": {
      "title": "Fichiers de marquage"
    },
    "findService": "Trouver le marquage correspondant",
    "noServiceGroupsMatchingPhrase": "Aucun groupe de marquage ne correspond à la recherche",
    "noServicesMatchingPhrase": "Aucune marquage ne correspond à la phrase fournie",
    "productionCompleteDate": "Date de fin de la production",
    "sample": {
      "sampleAcceptDate": "Date d’acceptation de l’essai",
      "sampleDate": "Date d’essai",
      "samplePhotosDateCreated": "Date d'ajout",
      "samplePhotosDownload": "Télécharger",
      "samplePhotosDownloadAll": "Tout télécharger",
      "samplePhotosSeePreview": "Afficher la photo de l’essai",
      "samplePhotosTitle": "Photos des échantillons",
      "sampleReceiveDate": "Date de réception de l’essai"
    },
    "sampleFiles": {
      "title": "Fichiers de l’essai"
    },
    "samples": {
      "noSamples": "Aucun essai",
      "rejectReason": "Raisons du rejet",
      "sample": "Test",
      "saveBeforeAddingFiles": "Sauvegarder la commande pour pouvoir ajouter des fichiers",
      "statuses": {
        "accepted": "Accepté",
        "rejected": "Refusé"
      },
      "title": "Essais de marquage"
    },
    "selectFileWithLogo": "Sélectionner le fichier avec le logo",
    "selectService": "Sélectionner la marquage",
    "selectedServiceName": "Marquage sélectionné",
    "service": "Marquage",
    "serviceCode": "Code du marquage",
    "serviceGroup": "Groupe de marquage",
    "serviceName": "Nom de la marquage",
    "serviceNotFound": "Marquage non trouvé",
    "serviceNotFoundDesc": "Aucun marquage correspondant n'a été trouvé pour le groupe de marquage, la complexité et les dimensions indiqués. Veuillez essayer une autre configuration.",
    "servicesPackage": {
      "dates": {
        "date": "Délai",
        "types": {
          "obtaining_at": "Date de réception de l'échantillon",
          "accepted_at": "Date de validation de l'échantillon",
          "sample_hpl_accepted_at": "Date de validation de l'échantillon"
        }
      }
    },
    "servicesPackageHideContents": "Masquer le contenu",
    "servicesPackageInvalidConfig": {
      "noMatchingService": "Aucun marquage correspondant pour la configuration spécifiée",
      "wrongDimensions": "Dimensions du marquage incorrectes"
    },
    "servicesPackageModify": "Modifier la taille et la complexité du marquage",
    "servicesPackageVariant": "Variante sélectionnée",
    "servicesPackageName": "Nom du pack de marquage",
    "servicesPackagePopup": {
      "addServicesPackage": "Ajouter un pack de marquage",
      "includedServices": "Marquages inclus dans le pack sélectionné :",
      "noServicesIncluded": "Aucun marquage n'est attribué au pack sélectionné.",
      "noServicesPackagesMatchingGivenPhrase": "Aucun pack ne correspond à la recherche",
      "selectServicesPackage": "Choisir le pack de marquage",
      "title": "Sélectionnez le pack de marquage à ajouter"
    },
    "servicesPackageShowContents": "Afficher le contenu",
    "setupPrice": "Frais de configuration (Setup)",
    "stitchNumber": "Nombre de points",
    "strandColors": "Couleurs de fils",
    "wrongDimensions": "Dimensions de marquage erronées",
    "wrongDimensionsDesc": "Veuillez indiquer la largeur et la hauteur du marquage"
  },
  "settings": {
    "country": {
      "country": "Pays",
      "countryCode": "Code de pays",
      "selectCountry": "Choisir le pays"
    },
    "currency": {
      "chooseCurrency": "Sélectionner une devise",
      "currency": "Devise",
      "noCurrenciesAvailable": "Aucun devise disponible..."
    },
    "language": {
      "chooseLanguage": "Sélectionner la langue",
      "noLanguagesAvailable": "Aucun langue disponible"
    },
    "transaltion": {
      "addTranslation": "Ajouter une traduction",
      "addTranslationErrorText": "L'ajout de la traductions a échoué. Réessayez.",
      "addTranslationSuccessText": "La traduction fournie a été sauvegardée",
      "addTranslationSuccessTitle": "Traduction ajoutée",
      "deleteTranslationConfirmTitle": "Êtes-vous sûr de vouloir supprimer cette traduction ?",
      "deleteTranslationErrorText": "La suppression de la traduction a échoué. Réessayez.",
      "deleteTranslationSuccessText": "La traduction sélectionnée a été supprimée",
      "deleteTranslationSuccessTitle": "Traduction supprimée",
      "editTranslation": "Modifier la traduction",
      "translationEditErrorText": "La modification de la traduction a échoué. Réessayez.",
      "translationEditSuccessText": "La traduction sélectionnée a été modifiée",
      "translationEditSuccessTitle": "Traduction modifiée",
      "translations": "Traductions"
    }
  },
  "settlements": {
    "amount": "Montant",
    "deadlines": "Délais",
    "invoiceList": "Liste des factures",
    "issued": "Émise",
    "noSettlementsToDisplay": "Aucune décompte à afficher",
    "paymentDueDate": "Paiement à",
    "settle": "Régler",
    "settled": "Réglé",
    "settlement": "Décompte",
    "settlements": "Décomptes",
    "type": "Type"
  },
  "shippers": {
    "chooseShipper": "Choisir le transitaire",
    "noShippersAvailable": "Aucun transitaire disponible"
  },
  "status": {
    "status": "Statut",
    "statusQuestionMark": "Statut ?"
  },
  "translation": {
    "editTranslation": "Modifier la traduction",
    "languageLocative": "langue",
    "languagesLocative": "langues",
    "missingTranslationsIn": "Traduction manquante en ",
    "noTranslationsToDisplay": "Aucune traduction disponible...",
    "systemName": "Nom système",
    "translated": "Traduit",
    "translationEditErrorText": "Une erreur est survenue lors de l'enregistrement des modifications. Veuillez réessayer...",
    "translationEditSuccessText": "Modifications des traductions enregistrées",
    "translationEditSuccessTitle": "Modifications enregistrées",
    "translationStatus": "Statut de la traduction",
    "translations": "Traductions",
    "translationsTitle": "Liste des traductions",
    "valueInPolish": "En polonais"
  },
  "ui": {
    "actionFailedTryAgain": "Opération échouée Réessayez.",
    "actions": "Actions",
    "add": "Ajouter",
    "addDescription": "Ajouter une description",
    "addNew": "Ajouter un nouveau",
    "addToCart": "Au panier",
    "address": "Adresse",
    "allFieldsAreRequired": "Tous les champs doivent être remplis.",
    "amount": "Quantité",
    "availability": "Disponibilité",
    "back": "Retour",
    "backToList": "Retour à la liste",
    "cancel": "Annuler",
    "cart": "Panier",
    "cartIsEmpty": "Le panier est vide",
    "chooseDate": "Sélectionner la date",
    "close": "Fermer",
    "companyName": "Nom de la société",
    "contactPerson": "Interlocuteur",
    "createOrderFromCart": "Créer une commande à partir de produits",
    "dataLoading": "Chargement des données en cours",
    "dataLoadingFailed": "Le chargement des données a échoué.",
    "daysOfWeek": {
      "fri": "Vendr",
      "mon": "Lun",
      "sat": "Sam",
      "sun": "Dim",
      "thur": "Jeu",
      "tue": "Mar",
      "wed": "Merc"
    },
    "deadlinePreferred": "Date préférée",
    "delete": "Supprimer",
    "deleteConfirmText": "Cette opération ne peut pas être annulée",
    "downloadInProgress": "Téléchargement en cours",
    "duplicate": "Duplique",
    "eMailCap": "E-mail",
    "eMailShort": "e-mail",
    "edit": "Modifier",
    "emailAddress": "Adresse e-mail",
    "errorOccured": "Une erreur s'est produite",
    "errorOccuredDuringDownload": "Une erreur s'est produite lors du chargement",
    "filtersSearch": "Rechercher",
    "generalInfo": "Informations générales",
    "importErrorTitle": "Une erreur s'est produite lors de l’importation",
    "importFile": "Importer le fichier",
    "importType": "Type d'importation",
    "inCart": "Dans le panier",
    "invoiceNumber": "Numéro de facture",
    "isSettled": "Réglés?",
    "lack": "Absence",
    "language": "Langue",
    "leadingPerson": "Responsable de la commande",
    "loadError": "UNE ERREUR DE CHARGEMENT S’EST PRODUITE",
    "markupProducts": "Marge sur les produits",
    "markupServices": "Marge sur les marquages",
    "markupSetupServices": "Marge sur la configuration (setup) des marquages",
    "markupShipping": "Marge sur la livraison",
    "monthNames": {
      "apr": "Av",
      "aug": "Août",
      "dec": "Déc",
      "feb": "Fév",
      "jan": "Jan",
      "jul": "Juil",
      "jun": "Ju",
      "mar": "Mars",
      "may": "Mai",
      "nov": "Nov",
      "oct": "Oct",
      "sep": "Sep"
    },
    "myOrders": "Mes commandes",
    "name": "Nom",
    "nameAndSurename": "Prénom et nom",
    "no": "Non",
    "noAvailabilityData": "Aucune donnée sur la disponibilité",
    "notSettled": "Non réglé",
    "ok": "OK",
    "okUnderstand": "D'accord, j'ai compris",
    "order": "Commande",
    "orderName": "Nom de la commande",
    "pagination": {
      "itemsAmount": "Nombre de positions :"
    },
    "partnerDiscountProducts": "Remise client sur los produits",
    "partnerDiscountServices": "Remise client sur les marquages",
    "partnerDiscountShipping": "Remise client sur la livraison",
    "phoneShort": "tel.",
    "pieces": "Unités",
    "piecesAbbr": "unit.",
    "piecesAmount": "Nombre d'unités",
    "productsGenitive": "Produits",
    "refNumber": "Numéro de référence",
    "refreshPage": "Rafraîchir la page",
    "repeatPassword": "Répéter le mot de passe",
    "resetFilters": "Réinitialiser les filtres",
    "saveChanges": "Sauvegarder les modifications",
    "search": "Rechercher",
    "searchFrom": " rechercher de",
    "searchTo": " à",
    "searching": "Recherche en cours",
    "selectContactPerson": "Sélectionner l'interlocuteur",
    "selectFile": "Sélectionner un fichier",
    "selectLeadingPerson": "Sélectionner le responsable de la commande",
    "selectedPersonNotFound": "Aucune personne sélectionnée",
    "settled": "Réglés",
    "shipper": "Transitaire",
    "sorting": {
      "asc": "Croissant",
      "availability": "Disponibilité",
      "code": "Code produit",
      "desc": "Décroissant",
      "label": "Trier par",
      "price": "Prix"
    },
    "supplier": "Fournisseur",
    "toTryAgain": "pour réessayer.",
    "tryAgain": "Réessayez",
    "value": "Valeur",
    "viewInNewTab": "Afficher dans un nouvel onglet",
    "yes": "Oui",
    "yesRemove": "Oui, supprimer"
  },
  "users": {
    "accountActive": "Compte actif",
    "accountInactive": "Compte inactif",
    "active": "Actifs",
    "addUser": "Ajouter un utilisateur",
    "addUserErrorText": "L'ajout de l’utilisateur a échoué. Réessayez.",
    "addUserSuccessText": "L'utilisateur fourni a été sauvegardé",
    "addUserSuccessTitle": "Utilisateur ajouté",
    "addingNewUser": "Ajout d’un nouvel utilisateur",
    "customer": "Client",
    "deleteConfirmTitle": "Êtes-vous sûr de vouloir supprimer cet utilisateur?",
    "deleteErrorText": "La suppression de l’utilisateur a échoué. Réessayez.",
    "deleteSuccessText": "L’utilisateur sélectionné a été supprimé",
    "deleteSuccessTitle": "Utilisateur supprimé",
    "editUser": "Modification de l’utilisateur",
    "editUserErrorText": "La modification de l'utilisateur a échoué. Réessayez.",
    "editUserSuccessText": "L'utilisateur sélectionné a été modifié",
    "editUserSuccessTitle": "Utilisateur modifié",
    "inactive": "Inactifs",
    "isAccountActive": "Compte actif?",
    "loggedInAs": "Connecté comme",
    "noUsersMatchingPhrase": "Aucun employé ne correspond à la phrase fournie",
    "noUsersToDisplay": "Aucun utilisateur à afficher",
    "selectWorker": "Sélectionner l'employé",
    "usersLabel": "Utilisateurs",
    "usersList": "Liste des utilisateurs",
    "usersSearchPlaceholder": "Fournir le prénom, le nom ou l’e-mail de l’utilisateur"
  },
  "validation": {
    "fieldCanContainAtLeast1Char": "Ce champ doit contenir au moins un caractère",
    "fieldCanContainAtLeast24Chars": "Ce champ doit contenir au moins {min} caractères",
    "fieldCanContainAtLeastNChars": "Ce champ doit contenir au moins {min} caractères",
    "fieldCanContainAtMax1Char": "Ce champ doit contenir au maximum un caractère",
    "fieldCanContainAtMax24Chars": "Ce champ doit contenir un maximum de {max} caractères",
    "fieldCanContainAtMaxNChars": "Ce champ doit contenir un maximum de {max} caractères",
    "onlyBigLetters": "Ce champ ne doit contenir que des lettres majuscules",
    "onlyLettersAndDashes": "Ce champ ne doit contenir que des lettres et des traits d'union",
    "onlyLettersAndNumbers": "Ce champ ne doit contenir que des lettres et des chiffres",
    "onlyNumbers": "Ce champ doit contenir un numéro",
    "onlyIntegerNumbers": "Ce champ doit contenir un nombre entier",
    "passwordsAreNotIdentical": "Les mots de passe ne sont pas identiques.",
    "required": "Ce champ est requis",
    "validDoubleNumericRequired": "Nombre requis au format 123.45",
    "validEmailRequired": "Ce champ doit contenir une adresse e-mail valide",
    "validUrlRequired": "Ce champ doit contenir une URL valide",
    "valueCannotBeGreaterThan": "La valeur ne doit pas être supérieure à",
    "valueCannotBeLessThan": "La valeur ne doit pas être inférieure à",
    "valueMustContainOrderID": "Le nom de la commande doit inclure l'identifiant de la commande :",
    "youMustSelectValue": "Vous devez sélectionner la valeur"
  },
  "welcome": {
    "baseballCaps": "Casquettes de baseball",
    "capVizors": "Visières",
    "choose": "Sélectionner",
    "clear": "Effacer",
    "clientPanel": "Panneau de client",
    "companyName": "Headwear",
    "filter": "Filtrer",
    "filterAvailability": "Filtrer par disponibilité",
    "filterByNameOrCode": "Filtrer par nom/code",
    "filterByPrice": "Filtrer par prix",
    "hats": "Chapeaux",
    "noProductsInSearchCriteria": "Absence de produits qui satisfont ces critères",
    "orderBy": "Trier par",
    "orderInfo": "Exécuter les commandes  <span class=\"text-primary font-weight-bold\"> en 5 étapes simples </span>: :",
    "productBrowserInfo": "Utilisez notre <span class=\"font-weight-bold\">moteur de recherche de produits</span>. Vous y trouverez des images de produits, des prix et des stocks. Vous pouvez également commencer à créer une commande à partir du moteur de recherche. Il suffit de cliquer sur  <span class=\"font-weight-bold\">\"Ajouter au panier\" à côté du produit</span>. Vous pouvez ensuite ajouter l'ensemble du panier à votre commande.",
    "requireAll": "Exiger tous",
    "searchProducts": "Rechercher le produit",
    "setp": "Étape",
    "stepFiveContent": "Cliquez sur le bouton  <span class=\"font-weight-bold\">\"Enregistrer l'offre\" </span> ou <span class=\"font-weight-bold\">\"Soumettre la commande pour traitement\".",
    "stepFourContent": "Complétez vos coordonnées de livraison et de contact dans l’onglet  <span class=\"font-weight-bold\">\"Données générales\"</span>.",
    "stepOneContent": "Aller dans l'onglet <span class=\"font-weight-bold\">\"Commandes\"</span>",
    "stepThreeContent": "Sous l'onglet  <span class=\"font-weight-bold\">\"Commande\"</span>, sélectionnez les produits et les marquages",
    "stepTwoContent": "Cliquez sur le bouton <span class=\"font-weight-bold\">\"Ajouter\"</span>",
    "wantToCheckOurProducts": "Vous souhaitez consulter rapidement nos produits et nos prix ?",
    "welcomeToClientPanel": "Bienvenue dans le panel de clients HeadWear",
    "winterHats": "Bonnets d'hiver"
  }
};
